import { NotificationBase } from './notification-base';

export class EmailNotificationProps extends NotificationBase {
	emailSubject = '';
	toEmail = '';
	emailMessage = '';

	constructor(init?: Partial<EmailNotificationProps>) {
		super(init);
		if (init) {
			Object.assign(this, init);
		}
	}
}
